<h1 mat-dialog-title>Kies media</h1>

<mat-dialog-content class="flex! flex-col">
  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-icon matPrefix>search</mat-icon>
    <input
      #searchInput
      matInput
      type="text"
      [placeholder]="viewMode() === 'system' ? 'Systeembestanden zoeken...' : 'Media zoeken...'"
      [ngModel]="keyword()"
      (ngModelChange)="handleSearch(searchInput.value)"
    />

    @if (keyword()) {
      <button mat-icon-button matSuffix class="mr-2" (click)="clearSearch()">
        <mat-icon>cancel</mat-icon>
      </button>
    }
  </mat-form-field>


  @if (!unitOnly) {
    <div class="flex gap-2 pt-2 pb-1">
      @if (isClientScope) {
        <button
          mat-button
          class="!rounded-full !min-w-0 !px-4 !h-8 !text-sm flex items-center"
          [class.!bg-secondary-100]="viewMode() === 'client'"
          [class.!text-secondary-800]="viewMode() === 'client'"
          (click)="switchView('client')"
        >
          <mat-icon class="!text-base !size-5 mr-1">person</mat-icon>
          Client
        </button>
      }
      @if (canReadMedia()) {
        <button
          mat-button
          class="!rounded-full !min-w-0 !px-4 !h-8 !text-sm flex items-center"
          [class.!bg-secondary-100]="viewMode() === 'unit'"
          [class.!text-secondary-800]="viewMode() === 'unit'"
          (click)="switchView('unit')"
        >
          <mat-icon class="!text-base !size-5 mr-1">folder</mat-icon>
          Unit
        </button>
      }
      @if (canShareMedia()) {
        <button
          mat-button
          class="!rounded-full !min-w-0 !px-4 !h-8 !text-sm flex items-center"
          [class.!bg-secondary-100]="viewMode() === 'shared'"
          [class.!text-secondary-800]="viewMode() === 'shared'"
          (click)="switchView('shared')"
        >
          <mat-icon class="!text-base !size-5 mr-1">folder_shared</mat-icon>
          Gedeeld
        </button>
      }
      @if (showSystemTab()) {
        <button
          mat-button
          class="!rounded-full !min-w-0 !px-4 !h-8 !text-sm flex items-center"
          [class.!bg-secondary-100]="viewMode() === 'system'"
          [class.!text-secondary-800]="viewMode() === 'system'"
          (click)="switchView('system')"
        >
          <mat-icon class="!text-base !size-5 mr-1">category</mat-icon>
          Systeem
        </button>
      }
    </div>
  }

  <div class="pt-2 pb-2 text-sm font-medium">
    @if (maxSelectionLimit(); as limit) {
      {{ selection.selected.length }} van {{ limit }} media geselecteerd
    } @else {
      {{ selection.selected.length }} media geselecteerd
    }
  </div>

  <div class="-mx-6 py-2 border-y border-gray-200 overflow-auto scrollbar-width-thin">
    <div class="flex flex-col gap-8 min-h-70">
      @if (!canReadMedia() && (viewMode() === 'unit' || viewMode() === 'client')) {
        <div class="px-6 pt-4 text-sm text-gray-500">
          Om media te kiezen heb je het recht "{{ mediaReadLabel }}" nodig.
        </div>
      }
      @if (showFolders()) {
        <div class="px-6">
          <div class="flex items-center min-h-10 mb-2">
            @if (stack().length) {
              <button mat-icon-button (click)="navigatePrevious()">
                <mat-icon>arrow_back</mat-icon>
              </button>
            }
            <span class="w-min max-w-40 truncate block text-sm font-medium">{{
              selectedNode()?.label ?? (viewMode() === 'shared' ? 'Gedeelde media' : viewMode() === 'client' ? 'Client media' : 'Home')
            }}</span>
          </div>

          <div class="grid grid-cols-2 gap-2">
            @for (group of groups(); track $index) {
              <div
                class="flex items-center bg-gray-200 rounded-lg p-2 pl-4 min-h-12 select-none hover:bg-gray-300 transition-colors"
                (dblclick)="navigateNext(group)"
              >
                <div class="flex flex-auto items-center overflow-hidden gap-2">
                  <mat-icon>{{ viewMode() === 'shared' ? 'folder_shared' : 'folder' }}</mat-icon>

                  <div class="flex flex-col flex-auto pr-2 min-w-0">
                    <span class="font-medium text-sm truncate">
                      {{ group.label }}
                    </span>
                    @if (viewMode() === 'shared' && group.unitLabel) {
                      <span class="text-xs text-gray-500 truncate">{{ group.unitLabel }}</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div class="px-6">
        <div class="grid grid-cols-3 gap-2">
          @for (media of dataSource(); track media.id) {
            <app-media-file-card
              [data]="media"
              [disabled]="submitted() || isMediaItemDisabled(media)"
              [persistent]="true"
              [selectable]="true"
              [selected]="selection.isSelected(media)"
              (selectionChange)="handleSelectionChange($event, $index)"
            />
          } @empty {
            <div class="col-span-full">Geen resultaten gevonden</div>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || !selection.selected.length"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>

